import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendResponse } from '../interface/table-column';
import { CreateUserRequest } from '../interface/license-manager';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private readonly http: HttpClient) {}
  activeTabIndex = 0;

  private baseUrl = 'api/License/'; // Change to your actual backend endpoint

  getLicenses(): Observable<BackendResponse> {
    return this.http.get<BackendResponse>(this.baseUrl + 'AllLicenses');
  }

  addUsers(users: CreateUserRequest ): Observable<{ message: string; emails: string[] }> {
    return this.http.post<{ message: string; emails: string[] }>(this.baseUrl + 'users', users);
  }

  setActiveTabIndex(index: number): void {
    this.activeTabIndex = index;
  }
}
